import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { parkingQueueKey } from './useAPIGetParkingQueue'

import { del } from 'api/apiClient'
import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

const deleteQueueItemResponseSchema = z.object({}).passthrough()

export type DeleteQueueItemInput = {
  queueId: number
  costPoolId: number
}

const buildUrl = (contractUuid: string, queueId: number, costPoolId: number) =>
  API_ENDPOINTS.RESIDENT_CONTRACT_PARKING_QUEUE_ITEM.replace(
    ':contractUuid',
    contractUuid
  )
    .replace(':queueId', String(queueId))
    .replace(':costPoolId', String(costPoolId))

export const useAPIDeleteParkingQueueItem = () => {
  const qc = useQueryClient()
  const { currentContractId } = useCurrentContract()

  return useMutation({
    mutationKey: currentContractId
      ? (['contracts', currentContractId, 'parking-queue', 'delete'] as const)
      : undefined,
    mutationFn: async ({ queueId, costPoolId }: DeleteQueueItemInput) => {
      if (!currentContractId) throw new Error('Missing contractUuid')
      if (!costPoolId) throw new Error('Missing costPoolId')

      await del(
        buildUrl(currentContractId, queueId, costPoolId),
        deleteQueueItemResponseSchema
      )
    },
    onSuccess: async () => {
      if (currentContractId) {
        await qc.invalidateQueries({
          queryKey: parkingQueueKey(currentContractId),
        })
      }
    },
  })
}
